import React from "react";
import { Redirect, Route } from "react-router-dom";

const PublicRoute: React.FC<any> = ({ component: Component, isAuthenticated, ...restOfProps }: any) => {
    return (
        <Route
            {...restOfProps}
            render={(props) =>
                !isAuthenticated ? <Component {...props} /> : <Redirect to={'/'} />
            } />
    );
}

export default PublicRoute;
